import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verifyPackageById } from "../../ApiController/ApiService"; // Adjust path as needed
import check from "../../assets/check.svg";
import Swal from "sweetalert2";

const ThanksPackage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(true);
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState(null);

  // ✅ Component load hote hi API hit karega
useEffect(() => {
  if (!id) {
    setError("Package ID is missing");
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Package ID is missing",
      confirmButtonColor: "#6F1AFF",
    });
    return;
  }

  const verifyPackage = async () => {
    setIsVerifying(true);
    setError(null);

const result = await verifyPackageById(id, 'Paid');

    if (result.success) {
      Swal.fire({
        icon: "success",
        title: "Thank You!",
        text: "Thank you for purchasing the package. Verified successfully!",
        confirmButtonColor: "#6F1AFF",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        navigate("/dashboard");
      });
    } else {
      setError(result.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Verification failed: " + result.message,
        confirmButtonColor: "#6F1AFF",
      });
    }

    setIsVerifying(false);
  };

  verifyPackage();
}, [id, navigate]);


  return (
    <div className="min-h-screen bg-[#F7F7F7] flex items-center justify-center">
      {isSuccessModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div
            className="bg-[#0F0D2E] p-8 rounded-2xl w-full max-w-md text-center"
            style={{ backdropFilter: "blur(42.7px)" }}
          >
            <h2
              style={{ fontFamily: "Poppins" }}
              className="text-[30px] font-bold text-white leading-tight"
            >
              Plan Upgraded{" "}
              <span className="text-[45px] text-[#6F1AFF]">Successfully</span>
            </h2>
            <p className="text-sm text-gray-400 mb-6 mt-1">
              Thank you for purchasing the package. Your plan has been upgraded
              successfully.
            </p>
            <div className="flex justify-center mb-6">
              <img src={check} alt="Checkmark" className="w-[197px] h-[156px]" />
            </div>

            {isVerifying && (
              <p className="text-gray-300 text-sm mt-4">Verifying package...</p>
            )}
            {error && <p className="text-red-400 text-sm mt-4">{error}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThanksPackage;
